module.exports = __webpack_public_path__ + "i18n/zh-CN.515730f996aeaf054d4f562a6245fa42.json";